import React from 'react'

export default function Services() {
  return (
    <div className='container py-5'>
        <p className='grey-text mb-3'>CRAFTMANSHIP</p>
        <p className='h3 fw600 mb-5'>My Services</p>
        <div className='row'>
            <div className="col-sm-12 col-lg-6 mb-4">
                <span style={{fontSize:"40px"}}><i class="bi bi-vector-pen text-primary"></i></span>
               <p className="h5 mb-3">Design</p>
               <p className="grey-text">I help communicate your ideas to the world through the use of well structured designs and products. I help provide a unique look for your brand that helps tell your story.</p> 
               <p className='grey-text'><strong className='text-primary'>Things I like to design: </strong>Logos, Flyers, Web UI</p>
               <p className='grey-text'><strong className='text-primary'>Design Tools: </strong>Figma, Adobe Photoshop, Pen & Jotter, Mockups</p>
            </div>
            <div className="col-sm-12 col-lg-6 mb-4">
                <span style={{fontSize:"40px"}}><i class="bi bi-file-earmark-code text-primary"></i></span>
               <p className="h5 mb-3">Development</p>
               <p className="grey-text">I'll help you incorporate your web application into your existing process and tools, assuring a finished result that fulfills your goals and converts your visitors, no matter what design, UX, or project management software you use.</p> 
               <p className='grey-text'><strong className='text-primary'>Proficient in: </strong>HTML, CSS, SASS, Javascript, React, ReactNative, NodeJs, Bootstrap, MongoDb, Firebase, EJS(templating engine), Wordpress(PHP)</p>
               <p className='grey-text'><strong className='text-primary'>Dev Tools: </strong>VsCode, Github, Codepen, MongoDB Compass, Terminal, Postman, Ngrok, Insonmia</p>
            </div>
           
        </div>
    </div>
  )
}
